// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"48":"3236a363","225":"d8c8e4c7","304":"0b736fc9","395":"e5fb8824","552":"12916637","791":"775bae45"}[chunkId] + ".chunk.js";
};